import { Controller } from 'react-hook-form'
import { InfoIcon } from '@chakra-ui/icons'
import {
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    Tooltip,
    VStack,
} from '@chakra-ui/react'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'

export function PenaltyNumberInput() {
    const { zodForm, isPenaltyOrderRequired, isFormDisabled } = useMatchEditorFormContext()

    if (!isPenaltyOrderRequired) {
        return null
    }

    return (
        <VStack mb={8} minW="90px" maxW="25%">
            <Controller
                control={zodForm.control}
                name="penalty_order"
                render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                    <FormControl isRequired isDisabled={isFormDisabled}>
                        <Flex>
                            <FormLabel htmlFor="penalty_order">Event #</FormLabel>
                            <Tooltip hasArrow label="Penalty Period Event Number (used for sorting)" size="xs" mt={1}>
                                <InfoIcon />
                            </Tooltip>
                        </Flex>
                        <NumberInput
                            min={1}
                            defaultValue={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            isDisabled={isFormDisabled}
                            isInvalid={!!error}
                            isRequired
                            value={value ?? 0}>
                            <NumberInputField ref={ref} name={name} />
                            <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                            </NumberInputStepper>
                        </NumberInput>
                        <FormErrorMessage>{zodForm.formState.errors.penalty_order?.message}</FormErrorMessage>
                    </FormControl>
                )}
            />
        </VStack>
    )
}
